<template>
  <div
    class="column"
    style="height: 100%;"
  >
    <div
      flat
      bordered
      class="panel-padding-data bg-grey-1"
      style="height:100%"
    >
      <div
        class=" column justify-start"
        :class="showReturnButton ? ' items-center' : ''"
        style=" height: 100%; "
      >
        <p class="title-preview-data full-width q-pb-sm row items-center justify-between">
          {{ contactName }}
          <q-badge
            v-if="contactStatus === 'DIALED' || contactHasDialed"
            color="green-8"
            label="Discado"
            style="padding: 5px;"
          />
        </p>

        <div
          class="data-container"
          :style="showReturnButton ? { maxHeight: '55vh', marginBottom: '2vh' } : {maxHeight: '60vh'}"
        >
          <div class="panel-box justify-between col">
            <div
              v-for="data in contactData"
              :key="data.id"
              class="preview-box"
            >
              <span class="preview-label text-bold ">{{ data.name }}</span>
              <div class="preview-data q-mt-xs">
                {{ formatValue(data.value) }}
              </div>
            </div>
          </div>
        </div>
        <q-btn
          v-if="showReturnButton"
          label="Retornar para contato"
          style="width: 230px; align-self: center;"
          no-caps
          outline
          padding="10px"
          icon="mdi-chevron-left"
          color="primary"
          @click="returnToPreview"
          :disabled="previewStatus === 'DIALING' || hasProfilerNotPerfilated"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ROUTE_PREVIEW_DETAILS } from '@/router/constants'
import { mapActions, mapGetters } from 'vuex'

export default {

  components: {

  },

  props: {
    queueId: {},
    showReturnButton: {
      type: Boolean,
      default: false
    },
    contact: {}
  },

  data () {
    return {
      disableButton: true
    }
  },

  mounted () {
    this.disableButton = this.callInCurrent
  },

  computed: {
    phones () {
      return this.contacts.phones.map((phone) => ({ number: phone.wa_id ?? phone.phone }))
    },
    attendanceId () {
      return this.$route.params.attendanceId
    },

    contactName () {
      if (!this.contact) return
      return this.contact.contactName
    },

    contactData () {
      if (!this.contact) return
      const data = this.contact.columns
      const dataSorted = [...data.sort((a, b) => a.id - b.id)]
      dataSorted.unshift({ name: this.contact.contactIdLabel, value: this.contact.contactId })
      return dataSorted
    },

    contactStatus () {
      if (!this.contact) return
      return this.contact.status
    },

    contactHasDialed () {
      return Object.values(this.contact.phones).some((phone) => ['COMPLETED', 'DISCARDED'].includes(phone.status))
    },

    ...mapGetters({
      previewStatus: 'attendanceModule/previewStatus'
    }),

    hasProfilerNotPerfilated () {
      const hasProfiler = this.$store.state.attendanceModule.profilers[this.attendanceId]
      if (!hasProfiler) return true
      const hasPerfilated = this.$store.state.attendanceModule.preview.contact[this.queueId].hasPerfilated
      return !hasPerfilated
    }

  },

  methods: {
    ...mapActions({
      removeAttendanceFromPreview: 'attendanceModule/removeAttendanceFromPreview'
    }),

    returnToPreview () {
      this.removeAttendanceFromPreview(this.attendanceId)
      this.$router.push({ name: ROUTE_PREVIEW_DETAILS, params: { queueId: this.queueId } }).catch(() => null)
    },

    formatValue (value) {
      return String(value).replace('00:00:00', '')
    }

  }

}

</script>
<style lang="sass" scoped>
.panel-padding-data
  border-radius: 3px
  border: 1px solid #c5c5c5
  height: 100%
  padding: 1vw 2vw

.preview-label
  border-radius: 5px
  font-size: 14px

.preview-data
  border-bottom: 1px solid #C5C5C5
  font-size: 12px
  font-color: #616161
  margin-bottom: 10px

.panel-box
  display: flex
  flex-direction: row
  flex-wrap: wrap
  height: 100%
  justify-content: space-between
  margin-bottom: 10px
  overflow-y: auto

.title-preview-data
  color: #000000
  font-size: 20px
  font-weight: 500
  border-bottom: 1px solid #C5C5C5

.preview-box
  display: flex
  flex-direction: column
  width: 45%

.data-container
  display: flex
  flex-direction: row
  flex-wrap: no-wrap
  width: 100%

@media only screen and (max-width: 1400px)
  .data-container
    display: flex
    flex-direction: column
    flex-wrap: no-wrap

  .panel-box
    width: 100%

  .preview-box
    width: 100%

</style>
